import React from 'react';

import { useLocation } from 'react-router-dom';

import { ReactComponent as ShareIcon } from '@pkg/assets/icons/v2/share.svg';
import { YatShareModule } from '@pkg/components';
import { useAppSelector } from '@pkg/hooks';

// import { FantasyRank } from './FantasyRank';
import { LiquidID } from './LiquidID';
import { UserBio } from './UserBio';
import { Wrapper as BioWrapper, TextStyles } from './UserBio/styles';
import { UserName } from './UserName';
import { TitleStyles, Wrapper as TitleWrapper } from './UserName/styles';
import { YatStatic } from './YatStatic';

import { ContentHolder, LeftSide, RightSide, SecondaryButton, ShareButton, Wrapper } from './styles';

function NonOwnerValue({ value, isBio = false }: { value?: string | null; isBio?: boolean }) {
    const Wrapper = isBio ? BioWrapper : TitleWrapper;
    const ValueStyle = isBio ? TextStyles : TitleStyles;
    const text = value || '...';
    return (
        <Wrapper>
            <ValueStyle>{text}</ValueStyle>
        </Wrapper>
    );
}
export const ProfileHeader = () => {
    const marketplaceV1Enabled = useAppSelector((state) => state.featureFlags.features.marketplaceV1Enabled);
    const isPageOwner = useAppSelector((state) => state.yatPage.isPageOwner);
    const username = useAppSelector((state) => state.yatPage.heading);
    const bio = useAppSelector((state) => state.yatPage.bio);
    const eid = useAppSelector((state) => state.yatPage.eid);

    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);
    const isPreview = queryParams.has('preview');

    const valuesMarkup =
        isPageOwner && !isPreview ? (
            <>
                <UserName username={username} />
                <UserBio bio={bio} />
            </>
        ) : (
            <>
                <NonOwnerValue value={username} />
                <NonOwnerValue value={bio} isBio />
            </>
        );

    return (
        <Wrapper $marketplaceEnabled={marketplaceV1Enabled}>
            <LeftSide>
                <LiquidID />
                <ContentHolder>
                    <YatStatic />
                    {valuesMarkup}
                    {
                        //marketplaceV1Enabled ? <FantasyRank /> : null
                    }
                </ContentHolder>
            </LeftSide>

            <RightSide>
                {isPageOwner && (
                    <>
                        {isPreview ? (
                            <SecondaryButton to={location.pathname}>Exit preview</SecondaryButton>
                        ) : (
                            <SecondaryButton to="?preview=1">Preview public profile</SecondaryButton>
                        )}
                    </>
                )}

                <YatShareModule
                    emojiId={eid as string}
                    customButton={
                        <ShareButton>
                            <ShareIcon />
                            Share
                        </ShareButton>
                    }
                    directionDown
                    directionLeft
                />
            </RightSide>
        </Wrapper>
    );
};
